import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import styled from 'styled-components'

import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Col } from 'core/components/ui'
import PageLoading from 'core/components/page-loading'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font } from 'assets/themes/theme-default'
import { stockShape } from '../shapes'
import FundingCard from './funding-card'

/******** ws */
const initialFundingList = [
  {
    label: 'Crédit classique',
    description:
      "Il s'agit d'un emprunt affecté exclusivement à un projet automobile qui vous est proposé par notre société interne de financement",
    bring: 0,
    maxStep: 48,
    minStep: 12,
    step: 6,
    monthly: 18,
    price: 328
  },
  {
    label: "Location avec option d'achat",
    description:
      "C'est une formule souple vous permettant de louer votre véhicule de 12 à 60 mois en bénéficiant d'une garantie et vous permettant d'acheter - ou non - votre véhicule au terme du contrat",
    bring: 0,
    maxStep: 48,
    minStep: 12,
    step: 6,
    monthly: 6,
    price: 425
  },
  {
    label: "Location avec option d'achat longue durée",
    description:
      "Il s'agit d'un contrat de location sur une durée de 12 à 60 mois, adaptée aux besoins des entreprises. Vous bénéficiez de services enrichis et ne vous préoccupez pas de la revente de votre véhicule",
    bring: 0,
    maxStep: 60,
    minStep: 12,
    step: 6,
    monthly: 24,
    price: 5385
  }
]
/************** */

const Title2Wrapper = styled.h2`
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgxs};
  text-transform: uppercase;
  color: ${props => props.theme.colors.color2.bg};
  margin: 0 0 15px 0;
`
const CardIcon = styled(SVG)`
  width: 40px;
  fill: ${props => props.theme.colors.color2.bg};
  margin-right: 10px;
`
const Funding = props => {
  // else load datas
  const { stock, setStock, intl, setWizards, wizards, history } = props

  const { filtersList } = stock

  const { fundingList } = filtersList

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_FUNDING) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsStock: extendedSteps }
    setWizards(extentedWizards)
  }

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.STOCK_FUNDING)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    const extendedFiltersList = {
      ...filtersList,
      fundingList: initialFundingList
    }

    const extendedStock = {
      ...stock,
      filtersList: extendedFiltersList
    }

    setTimeout(() => {
      setStock(extendedStock)
    }, 1000)

    activateNextStep()
  }, [])

  const renderList = () =>
    fundingList.map(item => (
      <Col span={8} key={item.label}>
        <FundingCard item={item} />
      </Col>
    ))

  return (
    <MainContentWrapper title={intl.formatMessage({ id: 'stock-funding-view-title' })}>
      <Title2Wrapper>
        <Row type="flex" align="middle">
          <Col>
            <CardIcon svg={svg.exclamationMark} />
          </Col>
          <Col>
            <FormattedMessage id="stock-funding-view-title-2" />
          </Col>
        </Row>
      </Title2Wrapper>

      {!fundingList ? <PageLoading /> : <Row gutter={30}>{renderList()}</Row>}
    </MainContentWrapper>
  )
}

Funding.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setStock: PropTypes.func.isRequired,
  stock: stockShape.isRequired
}

export default withRouter(injectIntl(Funding))
